module.exports = __webpack_public_path__ + "img/star.006ad447.svg";